import { render, staticRenderFns } from "./RomaPurpose.vue?vue&type=template&id=751e02bd"
import script from "./RomaPurpose.vue?vue&type=script&lang=ts"
export * from "./RomaPurpose.vue?vue&type=script&lang=ts"
import style0 from "./RomaPurpose.vue?vue&type=style&index=0&id=751e02bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports